import { Component, DestroyRef, ElementRef, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { SelectOneComponent } from '../../../../shared/components/select-one/select-one.component';
import { ButtonPadraoComponent } from '../../../../shared/components/button-padrao/button-padrao.component';
import { EscolhaTipoDisparoComponent } from '../escolha-tipo-disparo/escolha-tipo-disparo.component';
import { ExibicaoTemplateComponent } from '../exibicao-template/exibicao-template.component';
import { EmailPreviewComponent } from '../email-preview/email-preview.component';
import { MontadorEmailComponent, DadosMontadorEmail } from '../montador-email/montador-email.component';
import { ModalPreviewEmailComponent, DadosPreviewEmail } from '../modal-preview-email/modal-preview-email.component';
import { BlocoEmail, ModeloEmail, VariavelEmail } from '../../../../shared/model/email/modelo-email.model';
import { criarBloco, criarVariaveisEmail, montarHtmlEmail, normalizarNomeVariavel, substituirVariaveisEmail } from '../../../../shared/util/montar-html-email';
import { DisparoAutomaticoModel } from '../../../../shared/model/disparo-automatico/disparo-automatico.model';
import { TemplateSalvamentoModel } from '../../../../shared/model/template/template-salvamento-model';
import { FluxoSelect } from '../../../../shared/model/fluxo/fluxo-select-model';
import { DisparoAutomaticoVariavelModel } from '../../../../shared/model/disparo-automatico/disparo-automatico-variavel.model';
import { TemplateMensagemService } from '../../../../shared/service/template-mensagem.service';
import { FluxoService } from '../../../../shared/service/fluxo-service';
import { EtapaService } from '../../../../shared/service/etapa-service';
import { MsgService } from '../../../../shared/service/msg.service';
import { ValidacaoAlteracaoCampoService } from '../../../../shared/service/utilitarios/validacao-alteracao-campo.service';
import { ModalConfirmacaoComponent } from '../../../../shared/modais/modal-confirmacao/modal-confirmacao.component';

@Component({
  selector: 'app-forma-envio',
  standalone: true,
  imports: [
    SelectOneComponent,
    ButtonPadraoComponent,
    EscolhaTipoDisparoComponent,
    ExibicaoTemplateComponent,
    EmailPreviewComponent,
    MatMenuModule,
    MatIconModule,
  ],
  templateUrl: './forma-envio.component.html',
  styleUrl: './forma-envio.component.css',
})
export class FormaEnvioComponent implements OnInit, OnChanges {
  @Input() disparoAutomatico: DisparoAutomaticoModel = new DisparoAutomaticoModel();
  @Input() setorId?: number;
  @Input() anexo: any;
  @Input() variaveis: DisparoAutomaticoVariavelModel[] = [];
  @Input() colunasComplementares: string[] = [];
  @Input() listaContatos: any[] = [];
  @Input() programacaoAtiva = true;

  @Output() envioDisparoAutomatico = new EventEmitter<DisparoAutomaticoModel>();
  @Output() templateSelecionado = new EventEmitter<boolean>();
  @Output() variaveisCriadas = new EventEmitter<DisparoAutomaticoVariavelModel[]>();
  @Output() variaveisEmailPendentes = new EventEmitter<boolean>();

  private emailPossuiComplementarRemovida = false;

  templates: TemplateSalvamentoModel[] = [];
  fluxos: FluxoSelect[] = [];
  etapas: { id: number; titulo: string; descricao?: string }[] = [];

  carregandoTemplates = false;
  private canalTemplateId = 0;

  modeloEmail?: ModeloEmail;
  htmlPreviewEmail = '';
  arrastandoArquivo = false;
  @ViewChild('htmlInput') htmlInput!: ElementRef<HTMLInputElement>;

  private readonly destroyRef = inject(DestroyRef);
  aguardandoCargaInicialContatos = false;

  private readonly templateService = inject(TemplateMensagemService);
  private readonly fluxoService = inject(FluxoService);
  private readonly etapaService = inject(EtapaService);
  private readonly msgService = inject(MsgService);
  private readonly dialog = inject(MatDialog);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    const disparoExistente = !!(this.disparoAutomatico.id
      || this.disparoAutomatico.programacaoId
      || this.disparoAutomatico.ehProgramacaoRecorrente
      || this.possuiModeloEmail);
    this.aguardandoCargaInicialContatos = disparoExistente && !this.listaContatos?.length;
    this.buscarFluxos();
    if (this.disparoAutomatico.fluxo?.id) {
      this.carregarEtapas(this.disparoAutomatico.fluxo.id);
    }
    this.carregarTemplatesIniciais();
    this.sincronizarModeloEmail();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disparoAutomatico'] && !changes['disparoAutomatico'].firstChange) {
      const tipoAnterior = changes['disparoAutomatico'].previousValue?.tipoDisparo;
      const tipoAtual = this.disparoAutomatico.tipoDisparo;
      if (tipoAtual !== tipoAnterior) {
        this.carregarTemplatesIniciais();
      }
      const fluxoAnterior = changes['disparoAutomatico'].previousValue?.fluxo?.id;
      const fluxoAtual = this.disparoAutomatico.fluxo?.id;
      if (fluxoAtual && fluxoAtual !== fluxoAnterior) {
        this.carregarEtapas(fluxoAtual);
      }
      this.sincronizarModeloEmail();
    }
    if (changes['setorId'] && this.setorId && this.disparoAutomatico.tipoDisparo !== 'sms' && this.disparoAutomatico.tipoDisparo !== 'Email') {
      this.carregarTemplates(this.templateService.buscarTemplatesAprovadosDisparo('WHATSAPP'));
    }
    if (changes['listaContatos'] && !changes['listaContatos'].firstChange) {
      if (this.aguardandoCargaInicialContatos) {
        if (this.listaContatos?.length) {
          this.aguardandoCargaInicialContatos = false;
        }
      } else if (this.disparoAutomatico.tipoDisparo === 'Email') {
        this.resetarVariaveisEmail();
      }
    }
    if (changes['listaContatos'] || changes['colunasComplementares']) {
      this.atualizarPreviewEmail();
    }
  }

  private carregarTemplatesIniciais(): void {
    if (this.disparoAutomatico.tipoDisparo === 'sms') {
      this.carregarTemplates(this.templateService.buscarTemplatesAprovadosDisparo('SMS'));
    } else if (this.disparoAutomatico.tipoDisparo === 'Whatsapp') {
      this.carregarTemplates(this.templateService.buscarTemplatesAprovadosDisparo('WHATSAPP'));
    }
  }

  get edicaoRecorrente(): boolean {
    return !!this.disparoAutomatico.ehProgramacaoRecorrente;
  }

  get podeEditar(): boolean {
    if (this.disparoAutomatico.ehProgramacaoRecorrente) {
      return this.programacaoAtiva;
    }
    const status = this.disparoAutomatico.status;
    return !status || status === 'Agendado' || status === 'Aguardando Envio';
  }

  get bloqueado(): boolean {
    if (this.disparoAutomatico.ehProgramacaoRecorrente) return !this.podeEditar;
    const status = this.disparoAutomatico.status;
    return !(!status || status === 'Agendado' || status === 'Aguardando Envio');
  }

  prepararTipoDisparo() {
    return { Whatsapp: this.disparoAutomatico.tipoDisparo === 'Whatsapp', Email: this.disparoAutomatico.tipoDisparo === 'Email', sms: this.disparoAutomatico.tipoDisparo === 'sms' };
  }

  receberTipoDisparo(event: any) {
    const novoTipo = Object.entries(event)
      .filter(([, valor]) => valor)
      .map(([chave]) => chave)[0];

    const tipoAnterior = this.disparoAutomatico.tipoDisparo;
    const mudouCanal = tipoAnterior !== novoTipo;

    if (!novoTipo || !mudouCanal) {
      return;
    }

    if (tipoAnterior && this.possuiConteudoCanal(tipoAnterior)) {
      this.dialog
        .open(ModalConfirmacaoComponent, {
          data: {
            texto:
              'Se você trocar a forma de envio, a última configuração será descartada. Deseja prosseguir?',
          },
        })
        .afterClosed()
        .subscribe((confirmado) => {
          if (confirmado) {
            this.aplicarTrocaCanal(novoTipo);
            this.msgService.msgAdvertencia(
              'O conteúdo do tipo de envio anterior foi descartado ao trocar o canal.',
            );
          }
        });
      return;
    }

    this.aplicarTrocaCanal(novoTipo);
  }

  private aplicarTrocaCanal(novoTipo: string): void {
    this.disparoAutomatico.tipoDisparo = novoTipo;
    this.validarTipoDisparoSelecionado();
    this.carregarTemplatesPorCanal(novoTipo);
    this.alteracaoService.camposAlterado();
  }

  private possuiConteudoCanal(tipo: string | undefined): boolean {
    if (tipo === 'Email') {
      return !!this.disparoAutomatico.corpoHtmlEmail || !!this.modeloEmail;
    }
    return !!this.disparoAutomatico.template?.id;
  }

  carregarTemplatesPorCanal(tipo: string) {
    this.disparoAutomatico.template = undefined;
    this.disparoAutomatico.fluxo = undefined;
    this.disparoAutomatico.etapa = undefined;
    this.etapas = [];
    this.modeloEmail = undefined;
    this.htmlPreviewEmail = '';
    this.disparoAutomatico.assuntoEmail = undefined;
    this.disparoAutomatico.corpoHtmlEmail = undefined;
    this.disparoAutomatico.componentesEmail = [];
    this.envioDisparoAutomatico.emit(this.disparoAutomatico);
    this.limparPendenciaVariaveisEmail();
    if (tipo === 'sms') {
      this.carregarTemplates(
        this.templateService.buscarTemplatesAprovadosDisparo('SMS'),
      );
    } else if (tipo === 'Whatsapp') {
      this.carregarTemplates(
        this.templateService.buscarTemplatesAprovadosDisparo('WHATSAPP'),
      );
    } else {
      this.canalTemplateId++;
      this.templates = [];
      this.carregandoTemplates = false;
    }
  }

  carregarTemplatesWhatsapp() {
    this.carregarTemplates(this.templateService.buscarTemplatesAprovadosDisparo('WHATSAPP'));
  }

  carregarTemplatesDoSetor() {
    this.carregarTemplates(
      this.templateService.buscarTemplatesSetor(this.setorId!),
      () => this.msgService.msgErro('Erro ao buscar templates'),
    );
  }

  private carregarTemplates(
    origem$: Observable<TemplateSalvamentoModel[]>,
    onErro?: () => void,
  ) {
    const geracao = ++this.canalTemplateId;
    this.templates = [];
    this.carregandoTemplates = true;
    origem$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        if (geracao !== this.canalTemplateId) {
          return;
        }
        this.templates = res ?? [];
        this.removerTemplateNaoPermitido();
        this.carregandoTemplates = false;
      },
      error: () => {
        if (geracao === this.canalTemplateId) {
          this.carregandoTemplates = false;
        }
        onErro?.();
      },
    });
  }

  private removerTemplateNaoPermitido(): void {
    const templateAtual = this.disparoAutomatico.template;
    if (!this.podeEditar || !templateAtual?.id) {
      return;
    }
    const permitido = this.templates.some((template) => template.id === templateAtual.id);
    if (permitido) {
      return;
    }
    this.disparoAutomatico.template = undefined;
    this.templateSelecionado.emit(false);
    this.envioDisparoAutomatico.emit(this.disparoAutomatico);
    this.msgService.msgAdvertencia(
      'O template do disparo original não está disponível para o seu perfil. Selecione um novo template.',
    );
  }

  selecionarTemplate(event: any) {
    this.disparoAutomatico.template = event;
    this.templateSelecionado.emit(true);

    if (!this.disparoAutomatico.tipoDisparo && this.disparoAutomatico.template) {
      this.disparoAutomatico.tipoDisparo = 'Whatsapp';
    }
    this.envioDisparoAutomatico.emit(this.disparoAutomatico);
  }

  validarTipoDisparoSelecionado() {
    if (!this.disparoAutomatico.tipoDisparo) {
      this.disparoAutomatico.template = undefined;
    }
  }

  buscarFluxos() {
    this.fluxoService.buscarFluxoComTipoSelect().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.fluxos = (res ?? []).sort((a, b) =>
            (a.nome ?? '').localeCompare(b.nome ?? '', 'pt', {
              sensitivity: 'base',
            }),
          );
        },
      });
  }

  selecionarFluxo(fluxo: FluxoSelect | undefined) {
    this.disparoAutomatico.fluxo = fluxo;
    this.disparoAutomatico.etapa = undefined;
    this.etapas = [];
    if (fluxo?.id) {
      this.carregarEtapas(fluxo.id);
    }
  }

  carregarEtapas(fluxoId: number) {
    this.etapaService.buscarSelectPorFluxo(fluxoId).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.etapas = (res ?? []).map(etapa => ({
            ...etapa,
            tituloComId: `${etapa.titulo ?? 'Etapa'} (ID: ${etapa.id})`
          }));
          const etapaId = this.disparoAutomatico.etapa?.id;
          if (etapaId) {
            this.disparoAutomatico.etapa = this.etapas.find(etapa => etapa.id === etapaId)
              ?? this.disparoAutomatico.etapa;
          }
        }
      });
  }

  receberVariaveis(variaveis: DisparoAutomaticoVariavelModel[]) {
    this.variaveisCriadas.emit(variaveis);
  }

  get possuiModeloEmail(): boolean {
    return !!this.disparoAutomatico.corpoHtmlEmail || !!this.disparoAutomatico.componentesEmail?.length;
  }

  get variaveisEmail(): VariavelEmail[] {
    return criarVariaveisEmail(this.listaContatos?.[0], this.colunasComplementares);
  }

  get assuntoPreviewEmail(): string {
    return substituirVariaveisEmail(this.modeloEmail?.assunto, this.variaveisEmail);
  }

  private sincronizarModeloEmail(): void {
    if (this.disparoAutomatico.componentesEmail?.length) {
      const modelo = new ModeloEmail();
      modelo.assunto = this.disparoAutomatico.assuntoEmail ?? '';
      try {
        modelo.blocos = [...this.disparoAutomatico.componentesEmail]
          .sort((a, b) => a.ordem - b.ordem)
          .map((componente) => {
            const resto: BlocoEmail & { ordem?: number } = { ...componente };
            delete resto.ordem;
            return resto;
          });
        this.modeloEmail = modelo;
      } catch {
        this.modeloEmail = this.disparoAutomatico.corpoHtmlEmail
          ? this.modeloDeHtmlBruto(this.disparoAutomatico.corpoHtmlEmail)
          : undefined;
      }
    } else if (this.disparoAutomatico.corpoHtmlEmail) {
      this.modeloEmail = this.modeloDeHtmlBruto(
        this.disparoAutomatico.corpoHtmlEmail,
      );
    } else {
      this.modeloEmail = undefined;
    }
    this.atualizarPreviewEmail();
  }

  private atualizarPreviewEmail(): void {
    this.htmlPreviewEmail = this.modeloEmail ? montarHtmlEmail(this.modeloEmail, this.variaveisEmail) : '';
  }

  private static readonly CAMPOS_FIXOS_EMAIL = new Set(['nome', 'email', 'telefone', 'cpf']);

  private resetarVariaveisEmail(): void {
    if (!this.modeloEmail) {
      return;
    }

    let alterou = false;
    const removerTokensComplementares = (valor: string | undefined): string | undefined => {
      if (valor == null) {
        return valor;
      }
      const valorSemTokens = valor.replace(/\{\{\s*([^{}]+?)\s*\}\}/g, (token, nome: string) => {
        if (FormaEnvioComponent.CAMPOS_FIXOS_EMAIL.has(normalizarNomeVariavel(nome))) {
          return token;
        }
        alterou = true;
        return '';
      });
      return valorSemTokens;
    };

    this.modeloEmail.assunto = removerTokensComplementares(this.modeloEmail.assunto) ?? '';
    this.modeloEmail.blocos = this.modeloEmail.blocos.map((bloco) => ({
      ...bloco,
      texto: removerTokensComplementares(bloco.texto),
      html: removerTokensComplementares(bloco.html),
      labelBotao: removerTokensComplementares(bloco.labelBotao),
      urlBotao: removerTokensComplementares(bloco.urlBotao),
      urlImagem: removerTokensComplementares(bloco.urlImagem),
    }));

    if (!alterou) {
      return;
    }

    this.disparoAutomatico.assuntoEmail = this.modeloEmail.assunto;
    this.disparoAutomatico.corpoHtmlEmail = montarHtmlEmail(this.modeloEmail);
    this.sincronizarComponentesEmail();
    this.envioDisparoAutomatico.emit(this.disparoAutomatico);
    this.emailPossuiComplementarRemovida = true;
    this.variaveisEmailPendentes.emit(true);
    this.msgService.msgAdvertencia(
      'A lista de contatos foi alterada. As colunas complementares foram removidas das variáveis. ' +
      'As colunas Nome, E-mail, Telefone e CPF foram mantidas. Edite o e-mail para completar as variáveis removidas antes de salvar.',
    );
  }

  private modeloDeHtmlBruto(html: string): ModeloEmail {
    const modelo = new ModeloEmail();
    modelo.assunto =
      this.disparoAutomatico.assuntoEmail ||
      this.disparoAutomatico.tituloDisparo ||
      '';
    const bloco = criarBloco('HTML');
    bloco.html = html;
    modelo.blocos = [bloco];
    return modelo;
  }

  criarModeloEmail(): void {
    if (!this.podeEditar) {
      return;
    }
    this.abrirMontador();
  }

  editarModeloEmail(): void {
    if (!this.podeEditar) {
      return;
    }
    this.abrirMontador(this.modeloEmail);
  }

  abrirPreviewExpandido(): void {
    const dados: DadosPreviewEmail = {
      remetente: this.disparoAutomatico.emailRemetente,
      assunto: this.assuntoPreviewEmail,
      html: this.htmlPreviewEmail
    };
    this.dialog.open(ModalPreviewEmailComponent, {
      width: '95vw',
      maxWidth: '900px',
      height: '100vh',
      position: {
        top: '0',
        right: '0',
      },
      panelClass: 'slide-modal',
      autoFocus: false,
      data: dados,
    });
  }

  private abrirMontador(modelo?: ModeloEmail): void {
    const data: DadosMontadorEmail = { modelo, variaveis: this.variaveisEmail };
    const dialogRef = this.dialog.open(MontadorEmailComponent, {
      width: '95vw',
      maxWidth: '1600px',
      height: '100vh',
      position: {
        top: '0',
        right: '0',
      },
      panelClass: 'slide-modal',
      autoFocus: false,
      disableClose: true,
      data,
    });

    dialogRef.backdropClick().subscribe(() => {
      const podeFechar =
        !this.alteracaoService.isCamposAlteracao() ||
        window.confirm('Pode possuir alterações não salvas, deseja fechar?');
      if (podeFechar) {
        this.alteracaoService.camposNaoAlterados();
        dialogRef.close();
      }
    });

    dialogRef.afterClosed().subscribe((resultado: ModeloEmail | undefined) => {
      this.alteracaoService.camposNaoAlterados();
      if (resultado) {
        this.aplicarModeloEmail(resultado);
      }
    });
  }

  private aplicarModeloEmail(modelo: ModeloEmail): void {
    this.modeloEmail = modelo;
    this.disparoAutomatico.assuntoEmail = modelo.assunto;
    this.disparoAutomatico.corpoHtmlEmail = montarHtmlEmail(modelo);
    this.sincronizarComponentesEmail();
    this.atualizarPreviewEmail();
    this.envioDisparoAutomatico.emit(this.disparoAutomatico);
    this.limparPendenciaVariaveisEmail();
  }

  private limparPendenciaVariaveisEmail(): void {
    if (!this.emailPossuiComplementarRemovida) {
      return;
    }
    this.emailPossuiComplementarRemovida = false;
    this.variaveisEmailPendentes.emit(false);
  }

  private sincronizarComponentesEmail(): void {
    this.disparoAutomatico.componentesEmail = (this.modeloEmail?.blocos ?? []).map((bloco, ordem) => ({
      ...bloco,
      ordem
    }));
  }

  excluirModeloEmail(): void {
    if (!this.podeEditar) {
      return;
    }
    this.dialog
      .open(ModalConfirmacaoComponent, {
        data: { texto: 'Você deseja excluir esse e-mail?' },
      })
      .afterClosed()
      .subscribe((confirmado) => {
        if (confirmado) {
          this.confirmarExclusaoModeloEmail();
        }
      });
  }

  private confirmarExclusaoModeloEmail(): void {
    this.modeloEmail = undefined;
    this.htmlPreviewEmail = '';
    this.disparoAutomatico.assuntoEmail = undefined;
    this.disparoAutomatico.corpoHtmlEmail = undefined;
    this.disparoAutomatico.componentesEmail = [];
    this.envioDisparoAutomatico.emit(this.disparoAutomatico);
    this.limparPendenciaVariaveisEmail();
  }

  anexarModeloHtml(): void {
    if (!this.podeEditar) {
      return;
    }
    this.htmlInput.nativeElement.click();
  }

  aoSelecionarArquivoHtml(evento: Event): void {
    const input = evento.target as HTMLInputElement;
    const arquivo = input.files?.[0];
    if (arquivo) {
      this.processarArquivoHtml(arquivo);
    }
    input.value = '';
  }

  aoArrastarSobre(evento: DragEvent): void {
    if (!this.podeEditar) {
      return;
    }
    evento.preventDefault();
    this.arrastandoArquivo = true;
  }

  aoArrastarSair(evento: DragEvent): void {
    evento.preventDefault();
    this.arrastandoArquivo = false;
  }

  aoSoltarArquivo(evento: DragEvent): void {
    evento.preventDefault();
    this.arrastandoArquivo = false;
    if (!this.podeEditar) {
      return;
    }
    const arquivo = evento.dataTransfer?.files?.[0];
    if (arquivo) {
      this.processarArquivoHtml(arquivo);
    }
  }

  private processarArquivoHtml(arquivo: File): void {
    const nome = arquivo.name.toLowerCase();
    const ehHtml =
      nome.endsWith('.html') ||
      nome.endsWith('.htm') ||
      arquivo.type === 'text/html';
    if (!ehHtml) {
      this.msgService.msgAdvertencia('Selecione um arquivo .html válido.');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const conteudo = (reader.result as string) ?? '';
      const modelo = this.modeloDeHtmlBruto(conteudo);
      modelo.assunto =
        this.disparoAutomatico.assuntoEmail ||
        this.disparoAutomatico.tituloDisparo ||
        '';
      this.aplicarModeloEmail(modelo);
    };
    reader.onerror = () =>
      this.msgService.msgErro('Não foi possível ler o arquivo HTML.');
    reader.readAsText(arquivo);
  }
}
